import * as React from 'react';
import {styled} from '@packages/utilities/styled';
import {flexBoxStyles} from './FlexboxStyles';
import {type FlexboxProps} from './Flexbox.types';

const View = styled('div')(flexBoxStyles);

/**
 * @deprecated use `Stack`, `HStack`, or `VStack` from `@packages/systems/spring` instead
 */
export const Flexbox = React.forwardRef<any, FlexboxProps>((props, ref) => {
  return <View data-legacy-ds="Flexbox" {...props} ref={ref} />;
});

export default Flexbox;
